module.exports = __webpack_public_path__ + "assets/facebook.c3dc4454.svg";